import { useSelector } from 'react-redux';
import { CurrentUser, Author, Community, Role as R, State } from 'src/types';

export const userIsMemberOfCurrentGroup = (user: CurrentUser | null, community: Community | null) => {
  if (!user || !community) return false;
  const userGroups = user.followedCommunities || [];
  const userGroupIds = userGroups.map(grp => grp.communityId);
  return userGroupIds.includes(community.communityId);
};

export const userHasRole = (user: CurrentUser | Author | null, role: string | string[]) => {
  if (!user) return false;
  if (typeof role === 'string') {
    return user?.roles?.includes(role);
  } else {
    return user?.roles?.some(r => role.includes(r));
  }
};

export const userHasPermission = (user: CurrentUser | null, permission: string) => {
  if (!user) return false;
  return user?.permissions?.includes(permission);
};

export const useIsCommunityMember = (): boolean => {
  const { currentUser, currentCommunity } = useSelector(({context}: State) => context);
  if (!currentUser || !currentCommunity) return false;
  return currentUser.followedCommunities
    .map(({communityId}) => communityId)
    .includes(currentCommunity.communityId);
};

const editBy: {[key in R]: string[]} = {
  'HealthUnlocked': [],
  'Partner': [R.HealthUnlocked],
  'Administrator': [R.HealthUnlocked, R.Partner, R.Administrator],
  'Moderator': [R.HealthUnlocked, R.Partner, R.Administrator],
};

const getCanEditBy = (role: string, userRoles: string[]) => {
  return editBy[role as R]?.some((role: string) => userRoles.includes(role));
};

export const getCanEditBadges = (userRoles?: string[], memberRoles?: string[]): boolean => {
  if (!userRoles || userRoles.length === 0) return false;
  if (userRoles?.some(r => [R.HealthUnlocked, R.Partner, R.Administrator, R.Moderator].includes(r as R))) {
    if (memberRoles?.includes(R.HealthUnlocked)) return false;
    if (memberRoles?.includes(R.Partner)) return getCanEditBy(R.Partner, userRoles);
    if (memberRoles?.includes(R.Administrator)) return getCanEditBy(R.Administrator, userRoles);
    if (memberRoles?.includes(R.Moderator)) return getCanEditBy(R.Moderator, userRoles);
    return true;
  }
  return false;
};
